module.exports = "pegasus/assets/frame-twitter-old.png";